var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-warning-6935595") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-warning-6935595",
    fill: "#EE4B2B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.832,62.832 L46.164,62.832 L46.164,54.5 L37.832,54.5 L37.832,62.832 Z M42,0.332 C19.082,0.332 0.332,19.082 0.332,42 C0.332,64.918 19.082,83.668 42,83.668 C64.918,83.668 83.668,64.918 83.668,42 C83.668,19.082 64.918,0.332 42,0.332 Z M42,75.332 C23.668,75.332 8.668,60.332 8.668,42 C8.668,23.668 23.668,8.668 42,8.668 C60.332,8.668 75.332,23.668 75.332,42 C75.332,60.332 60.332,75.332 42,75.332 Z M37.832,46.168 L46.164,46.168 L46.164,21.168 L37.832,21.168 L37.832,46.168 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f7e1c40c5301cadbfafa354ff33f3234.svg";
export { ForwardRef as ReactComponent };